import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const LoadFormIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="5" width="16" height="16" rx="2" /><path d="M9 5.5V3h6v2.5M8 10h8M8 14h8M8 18h5" />
    </g>
  </SvgIcon>
)

export default LoadFormIcon
